import React, { useState } from "react";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";

//Import images
import avatar3 from "../../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../../assets/images/users/avatar-4.jpg";

//i18n
import { withTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { getLastMessages } from "helpers/fakebackend_helper";
import UserAvatarFromName from "components/Common/UserAvatarFromName";

const NotificationDropdown = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);

  const { data, isLoading } = useQuery
  ('last_messages', getLastMessages, {
    staleTime: 120000,
      refetchOnWindowFocus: false,
    });

    const unSeenMessageCount = data?.latest_messages?.filter(message => message.is_read === 0).length
  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="bx bx-message" />
          {unSeenMessageCount > 0 && <span className="badge bg-danger rounded-pill">{unSeenMessageCount}</span>}
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0"> {props.t("Messages")} </h6>
              </Col>
              <div className="col-auto">
                <Link to="/chat" className="small">
                  {" "}
                  View All
                </Link>
              </div>
            </Row>
          </div>

          <SimpleBar style={{ height: "230px" }}>
            {data?.latest_messages?.length > 0 ? (
              data.latest_messages.map((message) => (
                <Link to="" className="text-reset notification-item" key={message.id}>
                  <div className="d-flex">
                    <div className="avatar-xs me-3">
                      {/* <span className="avatar-title bg-primary rounded-circle font-size-16"> */}
                       <UserAvatarFromName name={message.sender_name} size="sm" />
                      {/* </span> */}
                    </div>
                    <div className="flex-grow-1">
                      <h6 className="mt-0 mb-1">
                        {message.sender_name}
                      </h6>
                      <div className="font-size-12 text-muted">
                        <p className="mb-1">
                          {message.message.slice(0, 10) + "..."}
                        </p>
                        <p className="mb-0">
                          <i className="mdi mdi-clock-outline" />{" "}
                          {new Date(message.created_at).toLocaleDateString([], {  month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' })}{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
              ))
            ) : (
              <div className="text-center p-3">
                <p>{props.t("No messages available")}</p>
              </div>
            )}
          </SimpleBar>
          <div className="p-2 border-top d-grid">
            <Link className="btn btn-sm btn-link font-size-14 text-center" to="/chat">
              <i className="mdi mdi-arrow-right-circle me-1"></i> <span key="t-view-more">{props.t("View More..")}</span>
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withTranslation()(NotificationDropdown);

NotificationDropdown.propTypes = {
  t: PropTypes.any
};